import React from 'react';

// Renders a real country flag image (flag emoji don't render on all fonts/OSes).
// `code` is an ISO 3166-1 alpha-2 country code (DE, BE, GB, ...).
export default function CountryFlag({ code, size = 22, className = '' }) {
  if (!code) return null;
  const c = String(code).toLowerCase();
  return (
    <img
      src={`https://flagcdn.com/${c}.svg`}
      alt={code}
      loading="lazy"
      className={`inline-block object-cover rounded-[2px] ring-1 ring-white/10 ${className}`}
      style={{ width: size * 1.4, height: size }}
    />
  );
}